export default {
    title: "管理部門",
    table1: "分行/子公司",
    table2: "部門編號",
    table3: "中文名",
    table4: "英文名",
    table5: "操作",
    isDel: "是否刪除當前部門？",
    addTitle: "添加部門",
    form1: "所屬分行/子公司：",
    form2: "部門編號：",
    form3: "部門名稱（中）：",
    form4: "部門名稱（英）：",
    form5: "電子郵箱：",
    form6: "聯繫人：",
    form7: "電話：",
    rule1: "請選擇所屬分行/子公司",
    rule2: "請輸入部門編號",
    rule3: "請輸入部門名稱（中）",
    rule4: "請輸入部門名稱（英）",
    rule5: "請輸入電子郵箱",
    rule6: "請輸入聯繫人",
    rule7: "請輸入電話",
    diaTitle: "編輯修改"
}